import React from 'react';
import { Button } from 'flowbite-react';
import { HiEye } from 'react-icons/hi';

interface ShowTargetButtonProps {
  onShowTarget: (showing: boolean) => void;
}

const ShowTargetButton: React.FC<ShowTargetButtonProps> = ({ onShowTarget }) => {
  return (
    <Button
      onMouseDown={(e) => {
        e.preventDefault();
        onShowTarget(true);
      }}
      onMouseUp={(e) => {
        e.preventDefault();
        onShowTarget(false);
      }}
      onMouseLeave={(e) => {
        e.preventDefault();
        onShowTarget(false);
      }}
      onTouchStart={(e) => {
        e.preventDefault();
        e.stopPropagation();
        // Prevent touch from triggering mouse events
        e.nativeEvent.stopImmediatePropagation();
        onShowTarget(true);
      }}
      onTouchEnd={(e) => {
        e.preventDefault();
        e.stopPropagation();
        // Prevent touch from triggering mouse events
        e.nativeEvent.stopImmediatePropagation();
        onShowTarget(false);
      }}
      onTouchCancel={(e) => {
        e.preventDefault();
        e.stopPropagation();
        // Prevent touch from triggering mouse events
        e.nativeEvent.stopImmediatePropagation();
        onShowTarget(false);
      }}
      onTouchMove={(e) => {
        // Prevent scrolling while touching the button
        e.preventDefault();
        e.stopPropagation();
      }}
      onContextMenu={(e) => {
        e.preventDefault();
        return false;
      }}
      style={{
        WebkitTouchCallout: 'none',
        WebkitUserSelect: 'none',
        KhtmlUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent'
      }}
      color="purple"
      size="md"
    >
      <HiEye className="mr-2 h-5 w-5" />
      Show Target (Hold)
    </Button>
  );
};

export default ShowTargetButton;